export default __webpack_public_path__ + "static/media/location_preview_s1_xplosion.20ca53ee.svg";